
import React from 'react';
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

interface FormField {
  id: string;
  label: string;
  type: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  readOnly?: boolean;
  helperText?: string;
}

interface RegistrationFormProps {
  fields: FormField[];
  onSubmit: (e: React.FormEvent) => void;
  loading: boolean;
  submitText: string;
  loadingText: string;
}

export const RegistrationForm = ({
  fields,
  onSubmit,
  loading,
  submitText,
  loadingText,
}: RegistrationFormProps) => {
  return (
    <>
      <Card className="bg-black/40 backdrop-blur-xl border border-white/10 p-8 shadow-2xl">
        <form onSubmit={onSubmit} className="space-y-6">
          {fields.map((field) => (
            <div key={field.id} className="space-y-2">
              <label 
                htmlFor={field.id} 
                className="block text-sm font-medium text-gray-200"
              >
                {field.label}
              </label>
              <Input
                id={field.id}
                name={field.id}
                type={field.type}
                value={field.value}
                onChange={field.onChange}
                placeholder={field.placeholder}
                className="bg-gray-900/50 border-gray-700 text-white placeholder:text-gray-400 focus:border-purple-500 focus:ring-purple-500 transition-all"
                readOnly={field.readOnly}
              />
              {field.helperText && (
                <p className="text-gray-400 text-xs">{field.helperText}</p>
              )}
            </div>
          ))}

          <Button
            type="submit"
            className="w-full bg-purple-600 hover:bg-purple-700 text-white font-medium py-2.5 transition-colors duration-200"
            disabled={loading}
          >
            {loading ? loadingText : submitText}
          </Button>
        </form>
      </Card>

      <p className="text-center text-gray-400 mt-6">
        Already have an account?{" "}
        <Link 
          to="/signin" 
          className="text-purple-400 hover:text-purple-300 font-medium transition-colors"
        >
          Sign in here
        </Link>
      </p>
    </>
  );
};
